import {Component,Input,OnInit} from '@angular/core';
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {HistoriqueEnveloppe,TypeLog,TypeNature,TypeSource} from "@domain/admin/entreprise/analytique/historique-enveloppe";
import {TranslateService} from "@ngx-translate/core";
import {HistoriqueItemComponent} from "@components/admin/entreprise/analytique/enveloppes/enveloppe-details/enveloppe-historique/historique-item/historique-item.component";

/**
 * Composant d'affichage de la page enveloppe historique
 *
 * @author Lionel Gimenez
 * @date 13/02/2025
 */
@Component({
    host: {'data-test-id': 'enveloppe-historique'},
    selector: 'enveloppe-historique',
    templateUrl: './enveloppe-historique.component.html'
})
export class EnveloppeHistoriqueComponent implements OnInit {

    /** Id de l'enveloppe */
    @Input() idEnveloppe: number;

    /** ListeView de l'historique */
    listeViewHistorique: ListView<HistoriqueEnveloppe,HistoriqueItemComponent>;

    /**
     * Constructeur
     */
    constructor(
        private translateService: TranslateService,
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        this.initListeHistorique();
    }

    /**
     * Initialisation de la liste historique
     * */
    initListeHistorique() {
        this.listeViewHistorique = new ListView<HistoriqueEnveloppe,HistoriqueItemComponent>({
            uri: `/controller/Budget/historiqueEnveloppe/${this.idEnveloppe}`,
            title: this.translateService.instant('admin.entreprise.analytique.enveloppes.onglets.historique'),
            component: HistoriqueItemComponent,
            isFilter: true,
            defaultOrder: '-dateLog',
            listeFilters: [
                {
                    clef: 'reference',
                    title: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.reference'),
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true
                },{
                    clef: 'sourceLog',
                    title: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.origine'),
                    listeValues: (Object.keys(TypeLog) as Array<keyof typeof TypeSource>)
                        .filter(key => !isNaN(Number(key)))
                        .map((key) => {
                            return {
                                code: key,
                                libelle: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.typeSource.' + key)
                            }
                        })
                },{
                    clef: 'dateLog',
                    type: TypeFilter[TypeFilter.DATE],
                    typeComparaison: 'EQUAL',
                    title: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.date'),
                },{
                    clef: 'acteur',
                    isDefault: true,
                    title: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.acteur')
                },{
                    clef: 'nature',
                    title: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.nature'),
                    listeValues: (Object.keys(TypeNature) as Array<keyof typeof TypeNature>)
                        .filter(key => !isNaN(Number(key)))
                        .map((key) => {
                            return {
                                code: key,
                                libelle: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.typeNature.' + key)
                            }
                        })
                },{
                    clef: 'typeLog',
                    title: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.typeModif'),
                    listeValues: (Object.keys(TypeLog) as Array<keyof typeof TypeLog>)
                        .filter(key => !isNaN(Number(key)))
                        .map((key) => {
                            return {
                                code: key,
                                libelle: this.translateService.instant('admin.entreprise.analytique.enveloppes.historique.typeLog.' + key)
                            }
                        })
                }
            ]
        });
    }
}